import type { CurrencyCode, ViewDef, ViewId } from './flow-types';

export const DAYS_OPTIONS = [7, 14, 30, 60, 90, 180];

export const CURRENCIES: Record<CurrencyCode, { sym: string; dec: number }> = {
  EUR: { sym: '€', dec: 2 },
  USD: { sym: '$', dec: 2 },
  GBP: { sym: '£', dec: 2 },
  CHF: { sym: 'CHF', dec: 2 },
};

export const VIEWS: Partial<Record<ViewId, ViewDef>> = {
  revolut: { label: 'Revolut', unit: 'USD' },
  crypto_ex_revolut: { label: 'Crypto', unit: 'EUR' },
  EUR: { label: 'EUR', unit: 'EUR' },
  USD: { label: 'USD', unit: 'EUR' },
  GBP: { label: 'GBP', unit: 'EUR' },
  CHF: { label: 'CHF', unit: 'EUR' },
};
export const DEFAULT_VIEWS: ViewId[] = ['revolut', 'crypto_ex_revolut', 'EUR', 'USD', 'GBP', 'CHF'];

export const GROUPS: [string, ViewId[]][] = [
  ['Revolut (USD)', ['revolut']],
  ['Non Revolut (EUR)', ['crypto_ex_revolut', 'EUR', 'USD', 'GBP', 'CHF']],
];

export const NET_COLOR = '#7f9cf0';
export const INCOMING_COLOR = '#34c4ae';
export const OUTGOING_COLOR = '#f2866b';

export const METRIC_COLORS: Record<'incoming' | 'outgoing' | 'net', string> = {
  incoming: INCOMING_COLOR,
  outgoing: OUTGOING_COLOR,
  net: NET_COLOR,
};

export const SHOW_TODAY_STATS = false;
